// extracted by mini-css-extract-plugin
export default {"page":"CheckoutPage_page__VoyM7","main":"CheckoutPage_main__BxIX4","footer":"CheckoutPage_footer__-Tz1r","summary":"CheckoutPage_summary__1zMl3"};